import { actions } from './bulk-actions.actions'
import { getters } from './bulk-actions.getters'
import { state } from './bulk-actions.state'
import { mutations } from './bulk-actions.mutations'

export default { actions, getters, state, mutations, namespaced: true }
